import React from 'react';

type OfertasFilterContextValue = {
	handleFilteredCarlines: (selectedButton: string) => void;
	selectedGamaFilter: string | null;
	selectedMotorizacionFilter: string | null;
	setSelectedGamaFilter: React.Dispatch<React.SetStateAction<string | null>>;
	setSelectedMotorizacionFilter: React.Dispatch<React.SetStateAction<string | null>>;
	setActiveCarlineIndex: (index: number) => void;
	anchorScrollOnFilter: () => void;
};

const OfertasFilterContext = React.createContext<OfertasFilterContextValue | null>(null);

export const OfertasFilterProvider: React.FC<{
	value: OfertasFilterContextValue;
	children: React.ReactNode;
}> = ({ value, children }) => {
	return <OfertasFilterContext.Provider value={value}>{children}</OfertasFilterContext.Provider>;
};

export const useOfertasFilterContext = (): OfertasFilterContextValue => {
	const context = React.useContext(OfertasFilterContext);

	if (!context) {
		throw new Error('useOfertasFilterContext must be used within OfertasFilterProvider');
	}

	return context;
};
